import { IconToggleFavoriteOn12 } from '@cian/ui-kit';

import { type ReactNode } from 'react';

import styles from './SuperAgentIcon.css';

export function SuperAgentIcon(): ReactNode {
  return (
    <div className={styles['circle']}>
      <IconToggleFavoriteOn12 color="white_100" />
    </div>
  );
}
